<atomic-message-bar type="info" class="mt-2 mb-4 flex"
	>Reconcile the borrower details provided by the lender with the purchaser(s)
	you have within this matter.</atomic-message-bar
>

<app-container class="overflow-auto">
	<app-llc-sync-header class="flex mt-2 items-center"></app-llc-sync-header>
	<div
		class="flex mt-2"
		*ngFor="let borrower of borrowers; trackBy: trackByllcClientId"
	>
		<div class="flex-1">
			<app-input
				[startIcon]="borrower?.icon"
				[label]="borrower?.label"
				[ngModel]="borrower.model"
				[disabled]="true"
			></app-input>
		</div>
		<div class="flex justify-center w-24 items-end mb-3">
			<app-icon [icon]="ICON.EQUAL"></app-icon>
		</div>
		<div class="flex-1">
			<app-llc-borrower-assign
				(onRemove)="onRemove(borrower)"
				[disabled]="
					signingOfficersMapping?.[borrower.llcClient.id] === null &&
					borrower.signingOfficer
				"
				label="Client"
				[prefilledNewClient]="borrower.prefilledNewClient"
				[(ngModel)]="borrower.closerClientId"
				[filterIds]="borrowerIds"
				(ngModelChange)="borrowerChanged()"
				[borrower]="borrower"
				[signingOfficer]="borrower.signingOfficer"
				[guarantor]="borrower.guarantor"
				[filterByParent]="!!borrower.signingOfficer"
				[parentId]="
					borrower.signingOfficer
						? signingOfficersMapping?.[borrower.llcClient.id]
						: ''
				"
			></app-llc-borrower-assign>
		</div>
	</div>
</app-container>

<div class="flex flex-1 justify-end mt-10">
	<app-button btn="secondary" (onClick)="_skip()" size="small" class="mr-3"
		>Skip</app-button
	>
	<app-button (onClick)="_next()" size="small" [loading]="saving"
		>Continue</app-button
	>
</div>
